import { Table, Text } from '@mantine/core';

import { AnnualReportOverviewCount } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Content } from '@/core/components';

interface AbstractCountProps {
  overview: AnnualReportOverviewCount;
}

export function AbstractCount({ overview: { papersCount } }: AbstractCountProps) {
  return (
    <Content type="full">
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w="80%">Numărul lucrărilor științifice publicate în rezumat</Table.Th>
            <Table.Td>
              <Text
                fs="xl"
                fw="500"
              >
                {papersCount.abstractsCount.totalCount}
              </Text>
            </Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Rezumate publicate în suplimente de reviste cotate ISI, CU factor de impact</Table.Th>
            <Table.Td>{papersCount.abstractsCount.isiWithFiAbstractsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Rezumate publicate în suplimente de reviste cotate ISI, FĂRĂ factor de impact</Table.Th>
            <Table.Td>{papersCount.abstractsCount.isiWithoutFiAbstractsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Rezumate publicate în suplimente de reviste indexate BDI</Table.Th>
            <Table.Td>{papersCount.abstractsCount.bdiAbstractsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>Rezumate publicate în suplimente de reviste recunoscute de CNCS – categoria B</Table.Th>
            <Table.Td>{papersCount.abstractsCount.cncsAbstractsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>
              Rezumate publicate în volume de rezumate cu ISBN/ISSN, internaționale (altele decât suplimentele de
              reviste)
            </Table.Th>
            <Table.Td>{papersCount.abstractsCount.internationalVolumeAbstractsCount}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>
              Rezumate publicate în volume de rezumate cu ISBN/ISSN, naționale (altele decât suplimente de reviste)
            </Table.Th>
            <Table.Td>{papersCount.abstractsCount.nationalVolumeAbstractsCount}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Content>
  );
}
